<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="checklistsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'checklists-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Checklists</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                @if (auth.checkPermission(PermissionType.Checklist, AccessType.Edit)) {
                    <dxi-item
                        location="after"
                        locateInMenu="never"
                    >
                        <dx-button
                            text="New Checklist"
                            icon="plus"
                            type="default"
                            stylingMode="contained"
                            (onClick)="addChecklist()"
                        ></dx-button>
                    </dxi-item>
                }
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>

            <dxi-column [dataField]="'employee.name'" caption="Employee" cellTemplate="employee" [minWidth]="250"
                        [calculateFilterExpression]="nameOrEmailFilter"></dxi-column>

            <dxi-column
                [dataField]="gridFieldName('assetType')"
                caption="Type"
                [minWidth]="100"
                cellTemplate="type"
                [lookup]="{ dataSource: assetTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
            ></dxi-column>

            <dxi-column [dataField]="gridFieldName('machineNumber')" caption="Machine #" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('equipmentNumber')" caption="Equipment #" [minWidth]="120"></dxi-column>

            <dxi-column
                [dataField]="gridFieldName('condition')"
                caption="Condition"
                [lookup]="{ dataSource: conditionOptions, valueExpr: 'value', displayExpr: 'text' }"
                [minWidth]="120"
                cellTemplate="condition"
            ></dxi-column>

            <dxi-column [dataField]="gridFieldName('created')" caption="Created" [minWidth]="150" dataType="date" [sortOrder]="'desc'"></dxi-column>

            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    {{ getCellData(cellInfo).number }}
                </div>
            </div>

            <div *dxTemplate="let cellInfo of 'employee'">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name"
                    [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).employee.id"
                ></user-avatar-email>
            </div>

            <div *dxTemplate="let cellInfo of 'type'">
                {{ cellInfo.value | assetType }}
            </div>

            <div *dxTemplate="let cellInfo of 'condition'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).condition)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>

        </dx-data-grid>
    </div>

    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('number')"
                editorType="dxTextBox"
                [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}"
            ></dxi-item>
            <dxi-item
                [dataField]="'employee.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('assetType')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Type',
                    stylingMode: 'filled',
                    items: assetTypeOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('machineNumber')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Machine #', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('equipmentNumber')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Equipment #', stylingMode: 'filled' }"
            ></dxi-item>
             <dxi-item
                [dataField]="filterModelName('condition')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Condition',
                    stylingMode: 'filled',
                    items: conditionOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('created')"
                editorType="dxDateBox"
                [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>
